import React from 'react';

import type { SvgProps } from 'react-native-svg';

import HeadPhoneSVG from '~/assets/svgs/headphone.svg';
import MapSVG from '~/assets/svgs/map.svg';
import GroupSVG from '~/assets/svgs/group.svg';
import WalletSVG from '~/assets/svgs/wallet.svg';
import ReceiptSVG from '~/assets/svgs/receipt.svg';
import ShiledSVG from '~/assets/svgs/protection-shield.svg';
import MoneySVG from '~/assets/svgs/money-bill.svg';
import FlagSVG from '~/assets/svgs/flag.svg';
import LucklyCloverSVG from '~/assets/svgs/luckly-clover.svg';

import { Text } from '~/components';
import { callNumber, openAppStore } from './device';

export const CONTACT_PHONE = '0800 024 4356';
export const CAPITALS_CONTACT_PHONE = '(11) 3047-4450';

export interface ItemProps {
  icon: React.FC<SvgProps>;
  title?: string;
  description: string | React.ReactElement;
}

export const marisaTakesCareResumeItems: ItemProps[] = [
  { icon: HeadPhoneSVG, description: 'Atendimento 24 horas' },
  { icon: MapSVG, description: 'Rede em todo território nacional' },
  {
    icon: WalletSVG,
    description:
      'Pagamento direto no local de acordo com os meios disponíveis (crédito, débito ou Pix)',
  },
  {
    icon: ReceiptSVG,
    description:
      'Valores reduzidos para serviços de bem-estar (massagem, drenagem, limpeza de pele)',
  },
  {
    icon: GroupSVG,
    description: (
      <Text>
        Inclusão de até 3 dependentes sem custo adicional e sem necessidade de
        vínculo familiar. O cadastramento deverá ser feito através do{' '}
        <Text
          className="font-medium text-primary-600"
          onPress={() =>
            openAppStore({
              ios: 'itms-apps://apps.apple.com/br/app/rede-mais-sa%C3%BAde/id1554672016',
              android:
                'https://play.google.com/store/apps/details?id=br.com.apprms&hl=es_US&gl=US&pli=1',
            })
          }
        >
          aplicativo Rede Mais
        </Text>{' '}
        ou pelo telefone{' '}
        <Text
          className="font-medium text-primary-600"
          onPress={() => callNumber(CONTACT_PHONE)}
        >
          {CONTACT_PHONE}
        </Text>
      </Text>
    ),
  },
];

export const bagProtectionResumeItems: ItemProps[] = [
  {
    icon: ShiledSVG,
    title: 'Fique protegida',
    description: (
      <Text>
        Indenização de até{' '}
        <Text className="text-primary-600 font-medium">R$ 2.000,00</Text> em
        transações indevidas realizadas com seu Cartão Marisa. Efetuadas em até
        96 horas do acionamento do seguro.
      </Text>
    ),
  },
  {
    icon: MoneySVG,
    title: 'Indenização de seus pertences',
    description: (
      <Text>
        Bolsa, carteira, telefone celular, óculos de sol ou de grau, cosméticos,
        perfume e chaves, limitado ao valor total de até{' '}
        <Text className="text-primary-600 font-medium">R$ 2.000,00</Text>
      </Text>
    ),
  },
  {
    icon: LucklyCloverSVG,
    title: 'Concorra a prêmios',
    description: (
      <Text>
        Você concorre toda semana à{' '}
        <Text className="text-primary-600 font-medium">R$ 1.500,00</Text> pela
        Loteria Federal (valor líquido de IR).
      </Text>
    ),
  },
];

export const incomeProtectionResumeItems: ItemProps[] = [
  {
    icon: ShiledSVG,
    title: 'Proteja-se de imprevistos',
    description: (
      <Text>
        Em caso de desemprego involuntário, você receberá até 4 parcelas de até
        R$ 500,00. Carência de 30 dias.
      </Text>
    ),
  },
  {
    icon: MoneySVG,
    title: 'Indenização',
    description: (
      <Text>
        Comodidade de auxiliar no pagamento de dívidas com a indenização de R$
        2.000,00 em caso de invalidez permanente total por acidente ou morte.
      </Text>
    ),
  },
  {
    icon: LucklyCloverSVG,
    title: 'Concorra a prêmios',
    description: (
      <Text>
        Você concorre toda semana à R$ 5.000,00 pela Loteria Federal (valor
        líquido de IR).
      </Text>
    ),
  },
  {
    icon: FlagSVG,
    title: 'Para clientes em regime CLT',
    description: (
      <Text>
        Seguro em caso de desemprego involuntário para pessoas entre 18 e 70
        anos que trabalham em regime CLT.
      </Text>
    ),
  },
];
